import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA, { InitializeOptions } from 'react-ga';

const usePageTracking = (trackingId: string, options?: InitializeOptions): void => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize(trackingId, options);
  }, [trackingId, options]);

  useEffect(() => {
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);
};

export default usePageTracking;
